<template>
	<div class="matchups">
		<h2 class="has-text-centered">
			<span v-if="heading">{{ heading }}</span>
			<span v-if="week_id">Week {{ week_id }} {{ is_complete ? "Results" : "Matchups" }}</span>
		</h2>

		<div class="box">
			<table class="table is-fullwidth is-hidden-mobile">
				<thead>
					<tr>
						<th>Team 1</th>
						<th colspan="2" class="has-text-centered">Points {{ is_complete ? "Scored" : "Projected" }}</th>
						<th>Team 2</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="matchup in matchups">
						<td><TeamLink :teamKey="matchup.team1_key" :teamName="matchup.team1_name" /></td>
						<td
							class="has-text-right"
							:class="{
								'has-text-weight-bold':
									is_complete &&
									(matchup.winner_team1 || (!matchup.winner_team2 && matchup.team1_key == matchup.winner_team_key)),
								'is-italic': !is_complete,
							}"
						>
							{{ matchup.team1_points }}
						</td>
						<td
							:class="{
								'has-text-weight-bold':
									is_complete &&
									(matchup.winner_team2 || (!matchup.winner_team1 && matchup.team2_key == matchup.winner_team_key)),
								'is-italic': !is_complete,
							}"
						>
							{{ matchup.team2_points }}
						</td>
						<td><TeamLink :teamKey="matchup.team2_key" :teamName="matchup.team2_name" /></td>
					</tr>
				</tbody>
			</table>

			<table class="table is-fullwidth is-hidden-tablet">
				<thead>
					<tr>
						<th>Teams</th>
						<th class="has-text-right">{{ is_complete ? "Scored" : "Projected" }}</th>
					</tr>
				</thead>
				<tbody>
					<template v-for="matchup in mobile_matchups">
						<tr class="has-next-row">
							<td><TeamLink :teamKey="matchup.team1_key" :teamName="matchup.team1_name" /></td>
							<td
								class="has-text-right"
								:class="{
									'has-text-weight-bold':
										is_complete &&
										(matchup.winner_team1 || (!matchup.winner_team2 && matchup.winner_team_key == matchup.team1_key)),
									'is-italic': !is_complete,
								}"
							>
								{{ matchup.team1_points }}
							</td>
						</tr>
						<tr>
							<td><TeamLink :teamKey="matchup.team2_key" :teamName="matchup.team2_name" /></td>
							<td
								class="has-text-right"
								:class="{
									'has-text-weight-bold':
										is_complete &&
										(matchup.winner_team2 || (!matchup.winner_team1 && matchup.winner_team_key == matchup.team2_key)),
									'is-italic': !is_complete,
								}"
							>
								{{ matchup.team2_points }}
							</td>
						</tr>
					</template>
				</tbody>
			</table>
		</div>

		<div class="cta-box has-text-centered is-hidden-tablet" v-if="is_mobile_limited">
			<a href="#" class="button is-medium is-rounded is-link is-outlined" @click.prevent="showMoreOnMobile">View more</a>
		</div>
	</div>
</template>

<script>
import TeamLink from "./TeamLink"

const LIMIT_MOBILE_MATCHUPS_COUNT = 3

export default {
	components: {
		TeamLink,
	},
	props: {
		heading: {
			type: String,
			default: null,
		},
		week_id: {
			type: Number,
			default: null,
		},
		is_complete: {
			type: Boolean,
			default: false,
		},
		matchups: {
			type: Array,
			required: true,
		},
		limit_mobile: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			is_mobile_shown_more: false,
		}
	},
	computed: {
		is_mobile_limited() {
			return this.limit_mobile && !this.is_mobile_shown_more && this.matchups.length > LIMIT_MOBILE_MATCHUPS_COUNT
		},
		mobile_matchups() {
			return this.is_mobile_limited ? this.matchups.slice(0, LIMIT_MOBILE_MATCHUPS_COUNT) : this.matchups
		},
	},
	methods: {
		showMoreOnMobile() {
			this.is_mobile_shown_more = true
		},
	},
}
</script>

<style scoped></style>
